// This file is auto-generated during the build process
export const BUILD_VERSION = "20260827-3";
export const BUILD_DATE = "2026-08-27T12:23:09.518Z";
